'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._crmFeatureIds = exports._cmsFeatureIds = exports._serviceEnterpriseFeatureIds = exports._serviceProfessionalFeatureIds = exports._serviceStarterFeatureIds = exports._serviceFreeFeatureIds = exports._salesEnterpriseFeatureIds = exports._salesProfessionalFeatureIds = exports._salesStarterFeatureIds = exports._salesFreeFeatureIds = exports._marketingEnterpriseFeatureIds = exports._marketingProfessionalFeatureIds = exports._marketingStarterFeatureIds = exports._marketingFreeFeatureIds = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _marketingFreeFeature, _extends2, _extends3, _extends4, _salesFreeFeatureIds2, _extends5, _extends6, _extends7, _serviceFreeFeatureId, _extends8, _extends9, _extends10, _cmsFeatureIds2, _crmFeatureIds2;

var _Features = require('self-service-api/constants/Features');

var _Features2 = _interopRequireDefault(_Features);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marketingFreeFeatureIds = exports._marketingFreeFeatureIds = (_marketingFreeFeature = {}, _defineProperty(_marketingFreeFeature, _Features2.default.ALL_CRM_FEATURES, {}), _defineProperty(_marketingFreeFeature, _Features2.default.FORMS, {
  shortLimitKey: 'limitedForms',
  longLimitKey: 'limitedForms'
}), _defineProperty(_marketingFreeFeature, _Features2.default.POPUP_FORMS, {
  shortLimitKey: 'nonCustomizable',
  longLimitKey: 'popupForms'
}), _defineProperty(_marketingFreeFeature, _Features2.default.EMAIL_MARKETING, {
  shortLimitKey: 'email2000SendsLimit',
  longLimitKey: 'emailMarketing'
}), _defineProperty(_marketingFreeFeature, _Features2.default.AD_MANAGEMENT, {
  shortLimitKey: 'limitedAdTypes1kSpendLimit',
  longLimitKey: 'adManagement'
}), _defineProperty(_marketingFreeFeature, _Features2.default.LIST_SEGMENTATION, {
  shortLimitKey: '5smartLists',
  longLimitKey: 'listSegmentation'
}), _defineProperty(_marketingFreeFeature, _Features2.default.COLLECTED_FORMS, {}), _defineProperty(_marketingFreeFeature, _Features2.default.NATIVE_FORMS, {
  shortLimitKey: 'additionalLimits',
  longLimitKey: 'nativeForms'
}), _defineProperty(_marketingFreeFeature, _Features2.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '1inbox',
  longLimitKey: 'conversationsInbox'
}), _defineProperty(_marketingFreeFeature, _Features2.default.TEAM_EMAIL, {}), _defineProperty(_marketingFreeFeature, _Features2.default.LIVE_CHAT, {}), _defineProperty(_marketingFreeFeature, _Features2.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'conversationalBots'
}), _defineProperty(_marketingFreeFeature, _Features2.default.MOBILE_OPTIMIZATION, {
  shortLimitKey: 'emailOnly',
  longLimitKey: 'mobileOptimization'
}), _defineProperty(_marketingFreeFeature, _Features2.default.USER_ROLES, {}), _defineProperty(_marketingFreeFeature, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '1standardDashboard',
  longLimitKey: 'reportingDashboardsMarketing'
}), _marketingFreeFeature);

var _marketingStarterFeatureIds = exports._marketingStarterFeatureIds = _extends({}, _marketingFreeFeatureIds, (_extends2 = {}, _defineProperty(_extends2, _Features2.default.POPUP_FORMS, {}), _defineProperty(_extends2, _Features2.default.NATIVE_FORMS, {
  shortLimitKey: 'brandingRemoved',
  longLimitKey: 'nativeForms'
}), _defineProperty(_extends2, _Features2.default.EMAIL_MARKETING, {
  shortLimitKey: 'email5xContactTierLimit',
  longLimitKey: 'emailMarketing'
}), _defineProperty(_extends2, _Features2.default.AD_MANAGEMENT, {
  shortLimitKey: 'limitedAdTypes1kSpendLimit',
  longLimitKey: 'adManagement'
}), _defineProperty(_extends2, _Features2.default.LIST_SEGMENTATION, {
  shortLimitKey: '25smartLists',
  longLimitKey: 'listSegmentation'
}), _defineProperty(_extends2, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '1standardDashboardWithProductivityReports',
  longLimitKey: 'reportingDashboardsMarketing'
}), _extends2));

var _marketingProfessionalFeatureIds = exports._marketingProfessionalFeatureIds = _extends({}, _marketingStarterFeatureIds, (_extends3 = {}, _defineProperty(_extends3, _Features2.default.FORMS, {}), _defineProperty(_extends3, _Features2.default.AD_MANAGEMENT, {
  shortLimitKey: 'allAdTypes10kSpendLimit',
  longLimitKey: 'adManagement'
}), _defineProperty(_extends3, _Features2.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '100inboxes',
  longLimitKey: 'conversationsInbox'
}), _defineProperty(_extends3, _Features2.default.NATIVE_FORMS, {}), _defineProperty(_extends3, _Features2.default.EMAIL_MARKETING, {
  shortLimitKey: 'email10xContactTierLimit',
  longLimitKey: 'emailMarketing'
}), _defineProperty(_extends3, _Features2.default.LIST_SEGMENTATION, {
  shortLimitKey: '1000smartLists',
  longLimitKey: 'listSegmentation'
}), _defineProperty(_extends3, _Features2.default.MOBILE_OPTIMIZATION, {}), _defineProperty(_extends3, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '1customDashboard',
  longLimitKey: 'reportingDashboardsMarketing'
}), _defineProperty(_extends3, _Features2.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'conversationalBots'
}), _defineProperty(_extends3, _Features2.default.PHONE_SUPPORT, {}), _defineProperty(_extends3, _Features2.default.CONTENT_CREATION_TOOLS, {}), _defineProperty(_extends3, _Features2.default.SEO_CONTENT_STRATEGY, {}), _defineProperty(_extends3, _Features2.default.GOOGLE_SEARCH_CONSOLE_INTEGRATION, {}), _defineProperty(_extends3, _Features2.default.CALLS_TO_ACTION, {}), _defineProperty(_extends3, _Features2.default.LANDING_PAGES, {}), _defineProperty(_extends3, _Features2.default.SSL_CERTIFICATE, {}), _defineProperty(_extends3, _Features2.default.SOCIAL_MEDIA, {
  shortLimitKey: '50socialMediaAccounts',
  longLimitKey: 'socialMedia'
}), _defineProperty(_extends3, _Features2.default.COMPETITORS, {
  shortLimitKey: '10competitors',
  longLimitKey: 'competitors'
}), _defineProperty(_extends3, _Features2.default.SUBDOMAIN_AVAILABILITY, {
  shortLimitKey: '1subdomain',
  longLimitKey: 'subdomainAvailability'
}), _defineProperty(_extends3, _Features2.default.MARKETING_AUTOMATION, {
  shortLimitKey: '300workflows',
  longLimitKey: 'workflows'
}), _defineProperty(_extends3, _Features2.default.SALESFORCE_INTEGRATION, {
  shortLimitKey: 'salesforce',
  longLimitKey: 'salesforce'
}), _defineProperty(_extends3, _Features2.default.SMART_CONTENT, {}), _defineProperty(_extends3, _Features2.default.ATTRIBUTION_REPORTING, {
  shortLimitKey: '1attributionModel',
  longLimitKey: 'attributionReporting'
}), _defineProperty(_extends3, _Features2.default.AB_TESTING, {}), _defineProperty(_extends3, _Features2.default.VIDEO_HOSTING_MANAGEMENT, {}), _defineProperty(_extends3, _Features2.default.TEAMS, {
  shortLimitKey: '25teams',
  longLimitKey: 'teamsProEnt'
}), _defineProperty(_extends3, _Features2.default.MULTI_CURRENCY, {
  shortLimitKey: '30currencies',
  longLimitKey: 'multiCurrency'
}), _defineProperty(_extends3, _Features2.default.CUSTOM_REPORTS, {
  shortLimitKey: '20customReports',
  longLimitKey: 'customReports'
}), _defineProperty(_extends3, _Features2.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '1scoringProperty',
  longLimitKey: 'standardContactScoring'
}), _defineProperty(_extends3, _Features2.default.AD_RETARGETING, {
  shortLimitKey: 'allAdTypes10kSpendLimit',
  longLimitKey: 'adRetargeting'
}), _defineProperty(_extends3, _Features2.default.CAMPAIGN_REPORTING, {
  shortLimitKey: '1000campaigns',
  longLimitKey: 'campaignReporting'
}), _defineProperty(_extends3, _Features2.default.FILTERED_ANALYTICS_VIEW, {
  shortLimitKey: '25views',
  longLimitKey: 'filteredAnalyticsViews'
}), _defineProperty(_extends3, _Features2.default.WEBSITE_TRAFFIC_ANALYTICS, {}), _extends3));

var _marketingEnterpriseFeatureIds = exports._marketingEnterpriseFeatureIds = _extends({}, _marketingProfessionalFeatureIds, (_extends4 = {}, _defineProperty(_extends4, _Features2.default.AD_MANAGEMENT, {
  shortLimitKey: 'allAdTypes30kSpendLimit',
  longLimitKey: 'adManagement'
}), _defineProperty(_extends4, _Features2.default.LIST_SEGMENTATION, {
  shortLimitKey: '1500smartLists',
  longLimitKey: 'listSegmentation'
}), _defineProperty(_extends4, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: '25customDashboards',
  longLimitKey: 'reportingDashboardsMarketing'
}), _defineProperty(_extends4, _Features2.default.SOCIAL_MEDIA, {
  shortLimitKey: '300socialMediaAccounts',
  longLimitKey: 'socialMedia'
}), _defineProperty(_extends4, _Features2.default.SUBDOMAIN_AVAILABILITY, {
  shortLimitKey: 'unlimitedSubdomains',
  longLimitKey: 'subdomainAvailability'
}), _defineProperty(_extends4, _Features2.default.MARKETING_AUTOMATION, {
  shortLimitKey: '500workflows',
  longLimitKey: 'workflows'
}), _defineProperty(_extends4, _Features2.default.ATTRIBUTION_REPORTING, {
  shortLimitKey: '5attributionModels',
  longLimitKey: 'attributionReporting'
}), _defineProperty(_extends4, _Features2.default.TEAMS, {
  shortLimitKey: '200teamsPlusHierarchical',
  longLimitKey: 'teamsProEnt'
}), _defineProperty(_extends4, _Features2.default.MULTI_CURRENCY, {
  shortLimitKey: '200currencies',
  longLimitKey: 'multiCurrency'
}), _defineProperty(_extends4, _Features2.default.CUSTOM_REPORTS, {
  shortLimitKey: '500customReports',
  longLimitKey: 'customReports'
}), _defineProperty(_extends4, _Features2.default.HIERARCHICAL_TEAMS, {
  shortLimitKey: '200teams',
  longLimitKey: 'hierarchicalTeams'
}), _defineProperty(_extends4, _Features2.default.CALCULATED_PROPERTIES, {
  shortLimitKey: '200properties',
  longLimitKey: 'calculatedProperties'
}), _defineProperty(_extends4, _Features2.default.CUSTOM_EVENT_TRIGGERS_AND_REPORTING, {}), _defineProperty(_extends4, _Features2.default.EVENT_BASED_SEGMENTATION, {}), _defineProperty(_extends4, _Features2.default.PREDICTIVE_LEAD_SCORING, {}), _defineProperty(_extends4, _Features2.default.SINGLE_SIGN_ON, {}), _defineProperty(_extends4, _Features2.default.CONTENT_PARTITIONING, {}), _defineProperty(_extends4, _Features2.default.CMS_MEMBERSHIP, {}), _defineProperty(_extends4, _Features2.default.YOUTUBE_INTEGRATION, {}), _defineProperty(_extends4, _Features2.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '25scoringProperties',
  longLimitKey: 'standardContactScoring'
}), _defineProperty(_extends4, _Features2.default.SOCIAL_PERMISSIONS, {}), _defineProperty(_extends4, _Features2.default.ADDITIONAL_DOMAINS, {}), _defineProperty(_extends4, _Features2.default.FILTERED_ANALYTICS_VIEW, {
  shortLimitKey: '25views',
  longLimitKey: 'filteredAnalyticsViews'
}), _defineProperty(_extends4, _Features2.default.EVENTS_API, {}), _defineProperty(_extends4, _Features2.default.AD_RETARGETING, {
  shortLimitKey: 'allAdTypes30kSpendLimit',
  longLimitKey: 'adRetargeting'
}), _extends4));

var _salesFreeFeatureIds = exports._salesFreeFeatureIds = (_salesFreeFeatureIds2 = {}, _defineProperty(_salesFreeFeatureIds2, _Features2.default.ALL_CRM_FEATURES, {}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.LIVE_CHAT, {}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'conversationalBots'
}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.TEAM_EMAIL, {}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '1inbox',
  longLimitKey: 'conversationsInbox'
}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.CALLING, {
  shortLimitKey: '15minutes',
  longLimitKey: 'calling'
}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.EMAIL_SCHEDULING, {}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.EMAIL_TRACKING_NOTIFICATIONS, {
  shortLimitKey: '200notifications',
  longLimitKey: 'emailTrackingNotifications'
}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.TEMPLATES, {
  shortLimitKey: '5templates',
  longLimitKey: 'emailTemplates'
}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.SNIPPETS, {
  shortLimitKey: '5snippets',
  longLimitKey: 'snippets'
}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.DOCUMENTS, {
  shortLimitKey: '5documents',
  longLimitKey: 'documents'
}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.MEETINGS, {
  shortLimitKey: '1link',
  longLimitKey: 'meetings'
}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: 'standardSalesReport1Dashboard',
  longLimitKey: 'reportingDashboardsSales'
}), _defineProperty(_salesFreeFeatureIds2, _Features2.default.DEAL_PIPELINE, {
  shortLimitKey: '1dealPipeline',
  longLimitKey: 'dealPipelines'
}), _salesFreeFeatureIds2);

var _salesStarterFeatureIds = exports._salesStarterFeatureIds = _extends({}, _salesFreeFeatureIds, (_extends5 = {}, _defineProperty(_extends5, _Features2.default.CALLING, {
  shortLimitKey: '8hours',
  longLimitKey: 'calling'
}), _defineProperty(_extends5, _Features2.default.EMAIL_TRACKING_NOTIFICATIONS, {
  shortLimitKey: 'unlimited',
  longLimitKey: 'emailTrackingNotifications'
}), _defineProperty(_extends5, _Features2.default.TEMPLATES, {
  shortLimitKey: '1000templates',
  longLimitKey: 'emailTemplates'
}), _defineProperty(_extends5, _Features2.default.SEQUENCES, {
  shortLimitKey: '1000sequences',
  longLimitKey: 'emailSequences'
}), _defineProperty(_extends5, _Features2.default.SNIPPETS, {
  shortLimitKey: '1000snippets',
  longLimitKey: 'snippets'
}), _defineProperty(_extends5, _Features2.default.DOCUMENTS, {
  shortLimitKey: '1000documents',
  longLimitKey: 'documents'
}), _defineProperty(_extends5, _Features2.default.MEETINGS, {
  shortLimitKey: '1000links',
  longLimitKey: 'meetings'
}), _defineProperty(_extends5, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: 'standardSalesReportWithProductivityReports',
  longLimitKey: 'reportingDashboardsSales'
}), _defineProperty(_extends5, _Features2.default.GOALS, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'salesGoals'
}), _defineProperty(_extends5, _Features2.default.EMAIL_SUPPORT, {}), _defineProperty(_extends5, _Features2.default.REP_PRODUCTIVITY_PERFORMANCE, {}), _defineProperty(_extends5, _Features2.default.CONVERSATION_ROUTING, {}), _extends5));

var _salesProfessionalFeatureIds = exports._salesProfessionalFeatureIds = _extends({}, _salesStarterFeatureIds, (_extends6 = {}, _defineProperty(_extends6, _Features2.default.WORKFLOWS_EXTENSIONS, {}), _defineProperty(_extends6, _Features2.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '100inboxes',
  longLimitKey: 'conversationsInbox'
}), _defineProperty(_extends6, _Features2.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'conversationalBots'
}), _defineProperty(_extends6, _Features2.default.CALLING, {
  shortLimitKey: '33hours',
  longLimitKey: 'calling'
}), _defineProperty(_extends6, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: 'standardSalesDashboard1CustomDashboard',
  longLimitKey: 'reportingDashboardsSales'
}), _defineProperty(_extends6, _Features2.default.DEAL_PIPELINE, {
  shortLimitKey: '50dealPipelines',
  longLimitKey: 'dealPipelines'
}), _defineProperty(_extends6, _Features2.default.PHONE_SUPPORT, {}), _defineProperty(_extends6, _Features2.default.DEAL_STAGE_TASK_LEAD_ROTATION_AUTOMATION, {
  shortLimitKey: '300workflows',
  longLimitKey: 'workflows'
}), _defineProperty(_extends6, _Features2.default.QUOTES, {
  shortLimitKey: '100quotesPerDeal',
  longLimitKey: '100quotesProEnt'
}), _defineProperty(_extends6, _Features2.default.SMART_SEND_TIMES, {}), _defineProperty(_extends6, _Features2.default.SALESFORCE_INTEGRATION, {
  shortLimitKey: 'salesforce',
  longLimitKey: 'salesforce'
}), _defineProperty(_extends6, _Features2.default.STRIPE_INTEGRATION, {
  shortLimitKey: 'stripeAccountRequired',
  longLimitKey: 'requiresStripeAccountEnt'
}), _defineProperty(_extends6, _Features2.default.REQUIRED_FIELDS, {}), _defineProperty(_extends6, _Features2.default.CUSTOM_REPORTS, {
  shortLimitKey: '20customReports',
  longLimitKey: 'customReports'
}), _defineProperty(_extends6, _Features2.default.MULTI_CURRENCY, {
  shortLimitKey: '30currencies',
  longLimitKey: 'multiCurrency'
}), _defineProperty(_extends6, _Features2.default.VIDEO_CREATION, {}), _defineProperty(_extends6, _Features2.default.SEQUENCE_QUEUES, {}), _defineProperty(_extends6, _Features2.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '1scoringProperty',
  longLimitKey: 'standardContactScoring'
}), _defineProperty(_extends6, _Features2.default.TEAMS, {
  shortLimitKey: '25teams',
  longLimitKey: 'teamsProEnt'
}), _defineProperty(_extends6, _Features2.default.VIDEO_HOSTING_MANAGEMENT, {}), _defineProperty(_extends6, _Features2.default.PRODUCTS, {}), _defineProperty(_extends6, _Features2.default.SLACK, {}), _extends6));

var _salesEnterpriseFeatureIds = exports._salesEnterpriseFeatureIds = _extends({}, _salesProfessionalFeatureIds, (_extends7 = {}, _defineProperty(_extends7, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: 'standardSalesDashboard25CustomDashboards',
  longLimitKey: 'reportingDashboardsSales'
}), _defineProperty(_extends7, _Features2.default.DEAL_STAGE_TASK_LEAD_ROTATION_AUTOMATION, {
  shortLimitKey: '500workflows',
  longLimitKey: 'workflows'
}), _defineProperty(_extends7, _Features2.default.CUSTOM_REPORTS, {
  shortLimitKey: '500customReports',
  longLimitKey: 'customReports'
}), _defineProperty(_extends7, _Features2.default.MULTI_CURRENCY, {
  shortLimitKey: '200currencies',
  longLimitKey: 'multiCurrency'
}), _defineProperty(_extends7, _Features2.default.HIERARCHICAL_TEAMS, {}), _defineProperty(_extends7, _Features2.default.PREDICTIVE_LEAD_SCORING, {}), _defineProperty(_extends7, _Features2.default.PLAYBOOKS, {
  shortLimitKey: '1000playbooks',
  longLimitKey: '1000playbooksEnt'
}), _defineProperty(_extends7, _Features2.default.ESIGN, {
  shortLimitKey: '30signatures',
  longLimitKey: '30signaturesEnt'
}), _defineProperty(_extends7, _Features2.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '25scoringProperties',
  longLimitKey: 'standardContactScoring'
}), _defineProperty(_extends7, _Features2.default.TEAMS, {
  shortLimitKey: '200teamsPlusHierarchical',
  longLimitKey: 'teamsProEnt'
}), _defineProperty(_extends7, _Features2.default.EVENTS_API, {}), _defineProperty(_extends7, _Features2.default.SINGLE_SIGN_ON, {}), _defineProperty(_extends7, _Features2.default.QUOTE_BASED_WORKFLOWS, {}), _defineProperty(_extends7, _Features2.default.GOALS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'salesGoals'
}), _defineProperty(_extends7, _Features2.default.RECURRING_REVENUE_TRACKING, {}), _defineProperty(_extends7, _Features2.default.CALCULATED_PROPERTIES, {}), _defineProperty(_extends7, _Features2.default.CALL_TRANSCRIPTION, {}), _defineProperty(_extends7, _Features2.default.CALLING_API, {}), _defineProperty(_extends7, _Features2.default.USER_ROLES, {}), _extends7));

var _serviceFreeFeatureIds = exports._serviceFreeFeatureIds = (_serviceFreeFeatureId = {}, _defineProperty(_serviceFreeFeatureId, _Features2.default.ALL_CRM_FEATURES, {}), _defineProperty(_serviceFreeFeatureId, _Features2.default.TICKETING, {}), _defineProperty(_serviceFreeFeatureId, _Features2.default.LIVE_CHAT, {}), _defineProperty(_serviceFreeFeatureId, _Features2.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '1inbox',
  longLimitKey: 'conversationsInbox'
}), _defineProperty(_serviceFreeFeatureId, _Features2.default.CALLING, {
  shortLimitKey: '15minutes',
  longLimitKey: 'calling'
}), _defineProperty(_serviceFreeFeatureId, _Features2.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'conversationalBots'
}), _defineProperty(_serviceFreeFeatureId, _Features2.default.TEAM_EMAIL, {}), _defineProperty(_serviceFreeFeatureId, _Features2.default.SNIPPETS, {
  shortLimitKey: '5snippets',
  longLimitKey: 'snippets'
}), _defineProperty(_serviceFreeFeatureId, _Features2.default.TEMPLATES, {
  shortLimitKey: '5templates',
  longLimitKey: 'emailTemplates'
}), _defineProperty(_serviceFreeFeatureId, _Features2.default.MEETINGS, {
  shortLimitKey: '1link',
  longLimitKey: 'meetings'
}), _defineProperty(_serviceFreeFeatureId, _Features2.default.TICKETS_CLOSED_REPORTS, {
  shortLimitKey: 'standardServiceReport1Dashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_serviceFreeFeatureId, _Features2.default.REP_PRODUCTIVITY_REPORTS, {
  shortLimitKey: 'standardServiceReport1Dashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_serviceFreeFeatureId, _Features2.default.TIME_TO_CLOSE_REPORTS, {
  shortLimitKey: 'standardServiceReport1Dashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_serviceFreeFeatureId, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: 'standardServiceReport1Dashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_serviceFreeFeatureId, _Features2.default.EMAIL_TRACKING_NOTIFICATIONS, {
  shortLimitKey: '200notifications',
  longLimitKey: 'emailTrackingNotifications'
}), _defineProperty(_serviceFreeFeatureId, _Features2.default.DOCUMENTS, {
  shortLimitKey: '5documents',
  longLimitKey: 'documents'
}), _serviceFreeFeatureId);

var _serviceStarterFeatureIds = exports._serviceStarterFeatureIds = _extends({}, _serviceFreeFeatureIds, (_extends8 = {}, _defineProperty(_extends8, _Features2.default.CALLING, {
  shortLimitKey: '8hours',
  longLimitKey: 'calling'
}), _defineProperty(_extends8, _Features2.default.SNIPPETS, {
  shortLimitKey: '1000snippets',
  longLimitKey: 'snippets'
}), _defineProperty(_extends8, _Features2.default.TEMPLATES, {
  shortLimitKey: '1000templates',
  longLimitKey: 'emailTemplates'
}), _defineProperty(_extends8, _Features2.default.SEQUENCES, {
  shortLimitKey: '1000sequences',
  longLimitKey: 'emailSequences'
}), _defineProperty(_extends8, _Features2.default.MEETINGS, {
  shortLimitKey: '1000links',
  longLimitKey: 'meetings'
}), _defineProperty(_extends8, _Features2.default.TICKETS_CLOSED_REPORTS, {
  shortLimitKey: 'standardServiceAndProductivityReport1Dashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends8, _Features2.default.REP_PRODUCTIVITY_REPORTS, {
  shortLimitKey: 'standardServiceAndProductivityReport1Dashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends8, _Features2.default.TIME_TO_CLOSE_REPORTS, {
  shortLimitKey: 'standardServiceAndProductivityReport1Dashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends8, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: 'standardServiceAndProductivityReport1Dashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends8, _Features2.default.EMAIL_SCHEDULING, {}), _defineProperty(_extends8, _Features2.default.EMAIL_TRACKING_NOTIFICATIONS, {
  shortLimitKey: 'unlimited',
  longLimitKey: 'emailTrackingNotifications'
}), _defineProperty(_extends8, _Features2.default.DOCUMENTS, {
  shortLimitKey: '1000documents',
  longLimitKey: 'documents'
}), _defineProperty(_extends8, _Features2.default.GOALS, {
  shortLimitKey: 'limitedFeatures',
  longLimitKey: 'serviceGoals'
}), _defineProperty(_extends8, _Features2.default.CONVERSATION_ROUTING, {}), _extends8));

var _serviceProfessionalFeatureIds = exports._serviceProfessionalFeatureIds = _extends({}, _serviceStarterFeatureIds, (_extends9 = {}, _defineProperty(_extends9, _Features2.default.CONVERSATIONAL_BOTS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'conversationalBots'
}), _defineProperty(_extends9, _Features2.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '100inboxes',
  longLimitKey: 'conversationsInbox'
}), _defineProperty(_extends9, _Features2.default.CALLING, {
  shortLimitKey: '33hours',
  longLimitKey: 'calling'
}), _defineProperty(_extends9, _Features2.default.TICKETS_CLOSED_REPORTS, {
  shortLimitKey: 'standardServiceDashboard1CustomDashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends9, _Features2.default.REP_PRODUCTIVITY_REPORTS, {
  shortLimitKey: 'standardServiceDashboard1CustomDashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends9, _Features2.default.TIME_TO_CLOSE_REPORTS, {
  shortLimitKey: 'standardServiceDashboard1CustomDashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends9, _Features2.default.MULTIPLE_TICKET_PIPELINES, {
  shortLimitKey: '50pipelines',
  longLimitKey: 'ticketPipelines'
}), _defineProperty(_extends9, _Features2.default.KNOWLEDGE_BASE, {}), _defineProperty(_extends9, _Features2.default.VIDEO_CREATION_AND_HOSTING, {}), _defineProperty(_extends9, _Features2.default.NPS_SURVEYS, {}), _defineProperty(_extends9, _Features2.default.CUSTOMER_EXPERIENCE_SURVEYS, {}), _defineProperty(_extends9, _Features2.default.CUSTOMER_SUPPORT_SURVEYS, {}), _defineProperty(_extends9, _Features2.default.INSIGHTS_DASHBOARD, {}), _defineProperty(_extends9, _Features2.default.CUSTOM_REPORTS, {
  shortLimitKey: '20customReports',
  longLimitKey: 'customReports'
}), _defineProperty(_extends9, _Features2.default.TICKET_STATUS_ROUTING_TASK_AUTOMATION, {
  shortLimitKey: '300workflows',
  longLimitKey: 'workflows'
}), _defineProperty(_extends9, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: 'standardServiceDashboard1CustomDashboard',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends9, _Features2.default.TEAMS, {
  shortLimitKey: '25teams',
  longLimitKey: 'teamsProEnt'
}), _defineProperty(_extends9, _Features2.default.SALESFORCE_INTEGRATION, {
  shortLimitKey: 'salesforce',
  longLimitKey: 'salesforce'
}), _defineProperty(_extends9, _Features2.default.PHONE_SUPPORT, {}), _defineProperty(_extends9, _Features2.default.CUSTOMER_FEEDBACK, {}), _defineProperty(_extends9, _Features2.default.MULTI_CURRENCY, {
  shortLimitKey: '30currencies',
  longLimitKey: 'multiCurrency'
}), _defineProperty(_extends9, _Features2.default.VIDEO_HOSTING_MANAGEMENT, {}), _defineProperty(_extends9, _Features2.default.SEQUENCE_QUEUES, {}), _defineProperty(_extends9, _Features2.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '1scoringProperty',
  longLimitKey: 'standardContactScoring'
}), _defineProperty(_extends9, _Features2.default.CUSTOMER_SERVICE_AUTOMATION, {
  shortLimitKey: '300workflows',
  longLimitKey: 'workflows'
}), _defineProperty(_extends9, _Features2.default.SLACK, {}), _extends9));

var _serviceEnterpriseFeatureIds = exports._serviceEnterpriseFeatureIds = _extends({}, _serviceProfessionalFeatureIds, (_extends10 = {}, _defineProperty(_extends10, _Features2.default.TICKETS_CLOSED_REPORTS, {
  shortLimitKey: 'standardServiceDashboard25CustomDashboards',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends10, _Features2.default.REP_PRODUCTIVITY_REPORTS, {
  shortLimitKey: 'standardServiceDashboard25CustomDashboards',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends10, _Features2.default.TIME_TO_CLOSE_REPORTS, {
  shortLimitKey: 'standardServiceDashboard25CustomDashboards',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends10, _Features2.default.CUSTOM_REPORTS, {
  shortLimitKey: '500customReports',
  longLimitKey: 'customReports'
}), _defineProperty(_extends10, _Features2.default.PLAYBOOKS, {
  shortLimitKey: '1000playbooks',
  longLimitKey: '1000playbooksEnt'
}), _defineProperty(_extends10, _Features2.default.CALL_TRANSCRIPTION, {}), _defineProperty(_extends10, _Features2.default.HIERARCHICAL_TEAMS, {}), _defineProperty(_extends10, _Features2.default.USER_ROLES, {}), _defineProperty(_extends10, _Features2.default.SINGLE_SIGN_ON, {}), _defineProperty(_extends10, _Features2.default.WEBHOOKS, {}), _defineProperty(_extends10, _Features2.default.TICKET_STATUS_ROUTING_TASK_AUTOMATION, {
  shortLimitKey: '500workflows',
  longLimitKey: 'workflows'
}), _defineProperty(_extends10, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: 'standardServiceDashboard25CustomDashboards',
  longLimitKey: 'serviceCustomDashboards'
}), _defineProperty(_extends10, _Features2.default.TEAMS, {
  shortLimitKey: '200teamsPlusHierarchical',
  longLimitKey: 'teamsProEnt'
}), _defineProperty(_extends10, _Features2.default.MULTI_CURRENCY, {
  shortLimitKey: '200currencies',
  longLimitKey: 'multiCurrency'
}), _defineProperty(_extends10, _Features2.default.CALCULATED_PROPERTIES, {}), _defineProperty(_extends10, _Features2.default.STANDARD_CONTACT_SCORING, {
  shortLimitKey: '25scoringProperties',
  longLimitKey: 'standardContactScoring'
}), _defineProperty(_extends10, _Features2.default.CUSTOMER_SERVICE_AUTOMATION, {
  shortLimitKey: '500workflows',
  longLimitKey: 'workflows'
}), _defineProperty(_extends10, _Features2.default.GOALS, {
  shortLimitKey: 'additionalFeatures',
  longLimitKey: 'serviceGoals'
}), _defineProperty(_extends10, _Features2.default.CALLING_API, {}), _defineProperty(_extends10, _Features2.default.EVENTS_API, {}), _extends10));

var _cmsFeatureIds = exports._cmsFeatureIds = (_cmsFeatureIds2 = {}, _defineProperty(_cmsFeatureIds2, _Features2.default.ALL_CRM_FEATURES, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.POPUP_FORMS, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.COLLECTED_FORMS, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.NATIVE_FORMS, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.PHONE_SUPPORT, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.AD_MANAGEMENT, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.LIST_SEGMENTATION, {
  shortLimitKey: '1000smartLists',
  longLimitKey: 'cmsListSegmentation'
}), _defineProperty(_cmsFeatureIds2, _Features2.default.MOBILE_OPTIMIZATION, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.CONTENT_CREATION_TOOLS, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.CALLS_TO_ACTION, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.LANDING_PAGES, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.SSL_CERTIFICATE, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.SMART_CONTENT, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.HUB_DB_DYNAMIC_CONTENT, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.WEBSITE_PAGES, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.DESIGN_MANAGER, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.STAGING_ENVIRONMENT, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.TEMPLATE_AND_MODULE_MARKETPLACE, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.WEBSITE_ANALYTICS, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.SEO_CONTENT_STRATEGY, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.GOOGLE_SEARCH_CONSOLE_INTEGRATION, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.CUSTOM_DOMAINS, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.UPTIME, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.CONTENT_DELIVERY_NETWORK, {}), _defineProperty(_cmsFeatureIds2, _Features2.default.SECURITY_MONITORING_THREAT_DETECTION, {}), _cmsFeatureIds2);

var _crmFeatureIds = exports._crmFeatureIds = (_crmFeatureIds2 = {}, _defineProperty(_crmFeatureIds2, _Features2.default.CONTACT_MANAGEMENT, {}), _defineProperty(_crmFeatureIds2, _Features2.default.CONTACT_WEBSITE_ACTIVITY, {}), _defineProperty(_crmFeatureIds2, _Features2.default.COMPANIES, {}), _defineProperty(_crmFeatureIds2, _Features2.default.DEALS, {}), _defineProperty(_crmFeatureIds2, _Features2.default.TASKS_AND_ACTIVITIES, {}), _defineProperty(_crmFeatureIds2, _Features2.default.COMPANY_INSIGHTS, {}), _defineProperty(_crmFeatureIds2, _Features2.default.GMAIL_AND_OUTLOOK_INTEGRATION, {
  shortLimitKey: 'gmailOutlook',
  longLimitKey: 'gmailOutlook'
}), _defineProperty(_crmFeatureIds2, _Features2.default.HUBSPOT_CONNECT_INTEGRATIONS, {}), _defineProperty(_crmFeatureIds2, _Features2.default.CUSTOM_SUPPORT_FORM_FIELDS, {}), _defineProperty(_crmFeatureIds2, _Features2.default.PROSPECTS, {}), _defineProperty(_crmFeatureIds2, _Features2.default.TICKETING, {}), _defineProperty(_crmFeatureIds2, _Features2.default.POPUP_FORMS, {
  longLimitKey: 'popupForms'
}), _defineProperty(_crmFeatureIds2, _Features2.default.NATIVE_FORMS, {
  shortLimitKey: 'branding',
  longLimitKey: 'crmNativeForms'
}), _defineProperty(_crmFeatureIds2, _Features2.default.AD_MANAGEMENT, {
  shortLimitKey: 'limitedAdTypes1kSpendLimit',
  longLimitKey: 'crmAdManagement'
}), _defineProperty(_crmFeatureIds2, _Features2.default.CONVERSATIONS_INBOX, {
  shortLimitKey: '1inbox',
  longLimitKey: 'crmConversationsInbox'
}), _defineProperty(_crmFeatureIds2, _Features2.default.REPORTING_DASHBOARDS, {
  shortLimitKey: 'standardReports1Dashboard',
  longLimitKey: 'crmReportingDashboards'
}), _defineProperty(_crmFeatureIds2, _Features2.default.EMAIL_TRACKING_NOTIFICATIONS, {
  shortLimitKey: '200notifications',
  longLimitKey: 'crmEmailTrackingNotifications'
}), _defineProperty(_crmFeatureIds2, _Features2.default.TEMPLATES, {
  shortLimitKey: '5templates',
  longLimitKey: 'crmEmailTemplates'
}), _defineProperty(_crmFeatureIds2, _Features2.default.SNIPPETS, {
  shortLimitKey: '5snippets',
  longLimitKey: 'crmSnippets'
}), _defineProperty(_crmFeatureIds2, _Features2.default.DOCUMENTS, {
  shortLimitKey: '5documents',
  longLimitKey: 'crmDocuments'
}), _defineProperty(_crmFeatureIds2, _Features2.default.CALLING, {
  shortLimitKey: '15minutes',
  longLimitKey: 'crmCalling'
}), _defineProperty(_crmFeatureIds2, _Features2.default.MEETINGS, {
  shortLimitKey: '1meetingLink',
  longLimitKey: 'crmMeetings'
}), _crmFeatureIds2);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/_MerchandiseFeatures.js
// module id = 427
// module chunks = 3 4 5